import { createImageViewModel } from 'interfaces/ImageViewModel';

export enum Images {
	// @ts-ignore
	widths = [2560, 1920, 1600, 1280],
	// @ts-ignore
	BackgroundImage = { ...createImageViewModel('media/9416780/homepage-bg_anaehoomalu_beach-2.jpg') },
}
